export default "__VITE_ASSET__CeOvoLl2__"